'use client';

import { useState, useEffect } from 'react';
import { useApiIsLoaded } from '@vis.gl/react-google-maps';
import { useBreakPoints } from '@/hooks/useBreakPoints';

type LogicProps = {
  address: string;
  mapCenter: { lat?: number; lng?: number };
};

export const useLogic = ({ mapCenter, address }: LogicProps) => {
  const { isMobile } = useBreakPoints();

  // デフォルトの緯度経度（既存のlistingInfoから）
  const defaultMapCenter =
    typeof mapCenter.lat === 'number' && typeof mapCenter.lng === 'number'
      ? {
          lat: mapCenter.lat,
          lng: mapCenter.lng,
        }
      : undefined;
  const [geocodedCenter, setGeocodedCenter] = useState<
    | {
        lat: number;
        lng: number;
      }
    | undefined
  >(defaultMapCenter);

  const apiLoaded = useApiIsLoaded();

  // 住所からジオコーディングで緯度経度を取得
  useEffect(
    () => {
      if (defaultMapCenter) {
        setGeocodedCenter(defaultMapCenter);
        return;
      } else {
        if (!apiLoaded) return;

        const geocoder = new google.maps.Geocoder();
        geocoder.geocode({ address }, (results, status) => {
          if (status === 'OK' && results && results[0]) {
            const loc = results[0].geometry.location;
            setGeocodedCenter({ lat: loc.lat(), lng: loc.lng() });
          } else {
            console.error('Geocode failed:', status, results);
          }
        });
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [apiLoaded],
  );

  return { isMobile, geocodedCenter };
};
